import React, { useMemo, useState } from "react";
import Modal from "@mui/material/Modal";
import { useTranslation } from 'react-i18next';

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import ShareIcon from "@mui/icons-material/Share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import * as colors from "@mui/material/colors";
import { HOST_URL } from "../../shared/constants";
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TelegramShareButton,
  TelegramIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

export const ShareRoute = (props) => {
    const { t } = useTranslation();
  
  const { pathUrls } = props;
  const [isOpen, setIsOpen] = useState(false);
  const URL = useMemo(() => {
    if (pathUrls?.length) {
      let url = `${HOST_URL}/direction?coordinates=`;
      for (const path of pathUrls) {
        url += `${path.startLocation.coordinates[0]}|${path.startLocation.coordinates[1]}|${path.endLocation.coordinates[0]}|${path.endLocation.coordinates[1]},`;
      }
      return url;
    }
  }, [pathUrls]);
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          bottom: 20,
          display: "flex",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            boxShadow: 1,
            padding: "10px 20px",
            backgroundColor: colors.common.white,
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
            transition: "0.5s ease-in-out",
            // transform: pathUrls?.length
            //   ? "translateY(0px)"
            //   : "translateY(102vh)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Typography variant="caption">{t('ShareDirection')}</Typography>
            <Button
              startIcon={<ShareIcon />}
              size="small"
              sx={{
                backgroundColor: colors.blue[700],
                color: colors.common.white,
                textTransform: "none",
                padding: "5px 15px",
                "&:hover": {
                  backgroundColor: colors.blue[600],
                },
              }}
              onClick={() => setIsOpen(true)}
            >
            {t('Share')}
            </Button>
          </Box>
        </Box>
      </Box>
      <Modal open={isOpen} onClose={() => setIsOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <FacebookShareButton url={URL}>
              <FacebookIcon size={30} />
            </FacebookShareButton>
            <TwitterShareButton url={URL}>
              <TwitterIcon size={30} />
            </TwitterShareButton>
            <EmailShareButton url={URL}>
              <EmailIcon size={30} />
            </EmailShareButton>
            <LinkedinShareButton url={URL}>
              <LinkedinIcon size={30} />
            </LinkedinShareButton>
            <TelegramShareButton url={URL}>
              <TelegramIcon size={30} />
            </TelegramShareButton>
            <WhatsappShareButton url={URL}>
              <WhatsappIcon size={30} />
            </WhatsappShareButton>
            <CopyToClipboard
              text={URL}
              onCopy={() =>
                toast.info("Link copied to clipboard", {
                  position: "bottom-right",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  closeButton: false,
                })
              }
            >
              <Button
                startIcon={<FileCopyOutlinedIcon />}
                size="small"
                sx={{
                  backgroundColor: colors.blue[700],
                  color: colors.common.white,
                  textTransform: "none",
                  padding: "5px 15px",
                  "&:hover": {
                    backgroundColor: colors.blue[600],
                  },
                }}
              >
                Copy
              </Button>
            </CopyToClipboard>
          </Box>
        </Box>
      </Modal>
    </>
  );
};


